/**
 * Accessible native select for CasaMapa chrome (locale/currency and forms).
 */
export default function CasaMapaSelect({
  id,
  label,
  value,
  options = [],
  onChange,
  disabled = false,
  compact = false,
  hideLabelVisually = false,
  error = "",
  className = "",
}) {
  const errorId = error ? `${id}-error` : undefined;

  return (
    <div
      className={[
        "cm-chrome-select",
        compact ? "cm-chrome-select--compact" : "",
        error ? "cm-chrome-select--error" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <label
        htmlFor={id}
        className={hideLabelVisually ? "cm-chrome-sr-only" : "cm-chrome-select__label"}
      >
        {label}
      </label>
      <select
        id={id}
        className="cm-chrome-select__control"
        value={value}
        disabled={disabled}
        aria-invalid={error ? true : undefined}
        aria-describedby={errorId}
        onChange={(event) => onChange?.(event.target.value)}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </select>
      {error ? (
        <p id={errorId} className="cm-chrome-select__error" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
